<template>
  <list-table
    :url="url"
    title="لیست انتقال وجه داخلی"
    :params="params"
    :fields="fields"
    :excelroute="''"
    :btns="btns"
  ></list-table>
</template>
  <script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CONFIRM_INTERNAL_TRANSFER,
  REJECT_INTERNAL_TRANSFER,
} from "@/core/services/store/internalTransfer.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "internalTransfer",
  data() {
    return {
      url: "internal_transfer",
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "sender_website",
          label: "وبسایت مبدا",
        },
        {
          key: "reciver_website",
          label: "وبسایت مقصد",
        },
        {
          key: "reciver_date",
          label: "تاریخ درخواست",
          formatter(value, key, item) {
            return value != null ? persianDate.getDate(value) : "-";
          },
        },
        {
          key: "sender_date",
          label: "تاریخ تایید",
          formatter(value, key, item) {
            return value != null ? persianDate.getDate(value) : "-";
          },
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return value.toLocaleString();
          },
        },

        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "بررسی شده" : "بررسی نشده";
          },
          tdClass(value, key, item) {
            var state = item.tracking_number;
            return state !== null ? "text-success" : "text-danger";
          },
        },
        {
          key: "tracking_number",
          label: "نتیجه عملیات",
        },
      ],
      params: [
        {
          label: "از تاریخ:",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
      ],
      btns: [],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "انتقال وجه داخلی" }]);
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>